var React = require('react');

function IconCloseRightInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_240_5967)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.77237e-06 -0.333335L22.6667 -0.333333L32 10.296L22.6667 21L1.90735e-06 21L3.77237e-06 -0.333335ZM21.4533 18.3333L28.456 10.3027L21.46 2.33333L2.66667 2.33333L2.66667 18.3333L21.4533 18.3333ZM13.3333 12.2187L9.88533 15.6667L8 13.7813L11.448 10.3333L8 6.88533L9.88534 5L13.3333 8.448L16.7813 5L18.6667 6.88533L15.2187 10.3333L18.6667 13.7813L16.7813 15.6667L13.3333 12.2187Z","fill":"white"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_240_5967"},React.createElement("rect",{"width":"32","height":"21","fill":"white"})))]);
}

IconCloseRightInline.defaultProps = {"width":"32","height":"21","viewBox":"0 0 32 21","fill":"none"};

module.exports = IconCloseRightInline;

IconCloseRightInline.default = IconCloseRightInline;
